import React from 'react';
import {CSSType} from "../../utils";
import {root, rootFullWidth} from "./styles";


export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: "primary"
    fullWidth?: boolean;
    overrideCss?: CSSType;
};

export const Button: React.FC<ButtonProps> = ({
    children,
    variant = "primary",
    fullWidth,
    overrideCss,
    ...rest
}) => {
    return (
        <button css={[root, fullWidth && rootFullWidth, overrideCss]} {...rest}>
            {children}
        </button>
    );
};